import clearIsDirty from '../../actions/clearIsDirty';
import getAdvertisingOptions from '../../selectors/gdprAdsV3Option/getAdvertisingOptions';
import { generateTcfString } from 'mini-mail-gdpr-ad-tcf';
import { orchestrator } from 'satcheljs';
import { saveGdprAdsV3Option } from '../../actions/gdprAdsV3/advertisingOptionsActions';
import {
    GdprAdsV3Options,
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

const saveGdprAdsV3OptionOrchestrator = orchestrator(saveGdprAdsV3Option, async () => {
    const options = getAdvertisingOptions();

    let disselectedVendorIdArray = [];
    let selectedVendorIdArray = [];
    if (options?.disselectedVendorId) {
        disselectedVendorIdArray = options.disselectedVendorId.slice() as number[];
    }
    if (options?.selectedVendorId) {
        selectedVendorIdArray = options.selectedVendorId.slice() as number[];
    }

    // If there is no 2 or 3 when do you the commit, we will push 3 as the default off value explicitly to indicate the first party cookie is turned off
    if (selectedVendorIdArray.indexOf(2) === -1 && selectedVendorIdArray.indexOf(3) === -1) {
        selectedVendorIdArray.push(3);
    }

    const allowedLegitimateInterestsBits = selectedVendorIdArray.indexOf(1) === -1;

    const gdprTcfPurposeFeatureCurrentBits = {
        allStoreAndAccessDevice: options.allStoreAndAccessDevice,
        allowPersonalisedAdsSelectBasicAd: options.allowPersonalisedAdsSelectBasicAd,
        allowPersonalisedAdsCreatePersonalisedAdsProfile:
            options.allowPersonalisedAdsCreatePersonalisedAdsProfile,
        allowPersonalisedAdsSelectPersonalisedAds:
            options.allowPersonalisedAdsSelectPersonalisedAds,
        allowPersonalisedAdsCreatePersonalisedContentProfile:
            options.allowPersonalisedAdsCreatePersonalisedContentProfile,
        allowPersonalisedAdsSelectPersonalisedContent:
            options.allowPersonalisedAdsSelectPersonalisedContent,
        allowPersonalisedAdsMeasureAdPerf: options.allowPersonalisedAdsMeasureAdPerf,
        allowPersonalisedAdsMeasureContentPerformance:
            options.allowPersonalisedAdsMeasureContentPerformance,
        allowPersonalisedAdsApplyMarketResearch: options.allowPersonalisedAdsApplyMarketResearch,
        allowDevelopAndImproveProduct: options.allowDevelopAndImproveProduct,
        allowPreciseGeoDataAndIdentifyDeviceGeoData:
            options.allowPreciseGeoDataAndIdentifyDeviceGeoData,
        allowPreciseGeoDataAndIdentifyDeviceScanDevice:
            options.allowPreciseGeoDataAndIdentifyDeviceScanDevice,
    };

    const gdprTcfObj = await generateTcfString(
        gdprTcfPurposeFeatureCurrentBits,
        allowedLegitimateInterestsBits,
        disselectedVendorIdArray
    );

    const savedOptions = getOptionsForFeature<GdprAdsV3Options>(OwsOptionsFeatureType.GdprAdsV3);

    const newOptions = {
        ...savedOptions,
        allStoreAndAccessDevice: options.allStoreAndAccessDevice,
        allowDevelopAndImproveProduct: options.allowDevelopAndImproveProduct,
        allowPersonalisedAds: options.allowPersonalisedAds,
        allowPersonalisedAdsSelectBasicAd: options.allowPersonalisedAdsSelectBasicAd,
        allowPersonalisedAdsApplyMarketResearch: options.allowPersonalisedAdsApplyMarketResearch,
        allowPersonalisedAdsMeasureContentPerformance:
            options.allowPersonalisedAdsMeasureContentPerformance,
        allowPersonalisedAdsSelectPersonalisedAds:
            options.allowPersonalisedAdsSelectPersonalisedAds,
        allowPersonalisedAdsMeasureAdPerf: options.allowPersonalisedAdsMeasureAdPerf,
        allowPersonalisedAdsSelectPersonalisedContent:
            options.allowPersonalisedAdsSelectPersonalisedContent,
        allowPersonalisedAdsCreatePersonalisedContentProfile:
            options.allowPersonalisedAdsCreatePersonalisedContentProfile,
        allowPersonalisedAdsCreatePersonalisedAdsProfile:
            options.allowPersonalisedAdsCreatePersonalisedAdsProfile,
        allowPreciseGeoDataAndIdentifyDevice: options.allowPreciseGeoDataAndIdentifyDevice,
        allowPreciseGeoDataAndIdentifyDeviceScanDevice:
            options.allowPreciseGeoDataAndIdentifyDeviceScanDevice,
        allowPreciseGeoDataAndIdentifyDeviceGeoData:
            options.allowPreciseGeoDataAndIdentifyDeviceGeoData,
        disselectedVendorId: disselectedVendorIdArray,
        selectedVendorId: selectedVendorIdArray,
        ...(gdprTcfObj
            ? {
                  encodedTCString: gdprTcfObj.encodedTCString,
                  vendorListVersion: gdprTcfObj.vendorListVersion,
              }
            : null),
    };

    await lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.GdprAdsV3,
        newOptions
    );

    clearIsDirty();
});

export default saveGdprAdsV3OptionOrchestrator;
